import { BulkProvisioningJobsTable } from './BulkProvisioningJobsTable.tsx';
import { useBulkProvisioningUpload } from '../Components/useBulkProvisioningUpload.ts';
import { bulkProvisioningDropAreaTestId } from '@/activityLog/bulkProvisioning/BulkProvisioningDataTestIds.ts';
import { useAbility } from 'permissions/hooks/useAbility.ts';
import { Actions, Subjects } from 'permissions/ability.ts';
import { UploadDialog } from '../Components/UploadDialog.tsx';
import { UploadSnackbar } from '@/activityLog/common/Upload/UploadSnackbar.tsx';
import { DropzoneWrapper } from '@/activityLog/common/Upload/DropzoneWrapper.tsx';

export const BulkProvisioningJobsDropTable = () => {
  const ability = useAbility();
  const { selectedFile, uploadFile, selectFile, importError, setImportError, isPending } =
    useBulkProvisioningUpload();

  return (
    <>
      <DropzoneWrapper
        onDrop={selectFile}
        disabled={ability.cannot(Actions.upload, Subjects.bulkProvisioning) || isPending}
        data-testid={bulkProvisioningDropAreaTestId}
      >
        <BulkProvisioningJobsTable />
      </DropzoneWrapper>
      <UploadDialog
        open={!!selectedFile && !importError}
        fileName={selectedFile?.name || ''}
        onConfirm={() => {
          if (isPending || importError) {
            return;
          }
          uploadFile();
        }}
        onCancel={() => {
          selectFile(null);
        }}
      />
      <UploadSnackbar
        importError={importError}
        onClose={function (): void {
          setImportError(null);
          selectFile(null);
        }}
      />
    </>
  );
};
